export function handlingSuccessCallback(callback, response) {
    if (callback && callback.onSuccess) {
        callback.onSuccess(response?.data);
    }
}

export function handlingErrorCallback(callback, error) {
    if (callback && callback.onError) {
        callback.onError(error);
    }
}
